import { useEffect, useState } from 'react';
import { isNumber } from 'src/util/core';

interface UsePageParamsProps {
    match?: any;
}

export const usePageParams = (props: UsePageParamsProps) => {
    const { match } = props;

    const [id, setId] = useState<number>();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const originId = match?.params?.id;

        const treatedId = Number(originId);

        if (treatedId && isNumber(treatedId)) {
            setId(treatedId);
            setIsReady(true);
        }
    }, [match?.params?.id]);

    return {
        id,
        isReady,
    };
};
